import { Routes } from '@angular/router';
import { UserListComponent } from './components/user-list/user-list.component';
import { RoleListComponent } from './components/role-list/role-list.component';
import { AccountListComponent } from './components/account-list/account-list.component';
import { AccountEditComponent } from './components/account-edit/account-edit.component';

export const moduleRoutes: Routes = [
    {
        path: 'accounts',
        component: AccountListComponent
    },
    {
        path: 'accounts/add',
        component: AccountEditComponent
    },
    {
        path: 'accounts/edit/:id',
        component: AccountEditComponent
    },    
    {
        path: 'roles',
        component: RoleListComponent
    },
    {
        path: 'users',
        component: UserListComponent
    }    
]